// Which screen /scan and /covers open (phase 4 §5.10): for a member who may
// add, a type whose covers can be read (films, series, books) gets the one
// capture screen — barcodes read and covers photographed at once; any other
// type, and readers, keep the barcode scanner. Small on purpose: the shell
// and the collection page read it, the screens are loaded on their pages.
import { COVER_PRESETS, coverTypes } from '../covers/coverable';
import { isScannable, scannableTypes } from '../scan/scannable';

/** True for a type the capture screen serves (its covers can be read). */
export const capturesCovers = (type) => !!type && COVER_PRESETS.includes(type.preset);

/** The collection's types the scanner or the capture screen serve, its default first. */
export const captureTypes = (inventory) => {
  const seen = new Set();
  return [...coverTypes(inventory), ...scannableTypes(inventory)]
    .filter(type => (seen.has(type.id) ? false : seen.add(type.id)))
    .sort((a, b) => {
      const preferred = inventory && inventory.default_item_type ? inventory.default_item_type.id : null;
      return Number(b.id === preferred) - Number(a.id === preferred);
    });
};

/** The type a screen opens on: the one asked for (?type=), else the first. */
export const pickType = (types, wanted) => types.find(type => String(type.id) === String(wanted)) || types[0] || null;

/**
 * True when /scan (or /covers) opens the capture screen: the member may add
 * and the type it opens on is one whose covers can be read.
 */
export const opensCapture = (inventory, wanted, canEdit) => !!canEdit && capturesCovers(pickType(captureTypes(inventory), wanted));

/** True when the collection has something to scan or photograph for this member. */
export const canCapture = (inventory, canEdit) => scannableTypes(inventory).length > 0 || (!!canEdit && coverTypes(inventory).length > 0);

/** Films, series and video games: the shutter first (their codes are often unknown, a cartridge has none); books: the barcode first. */
export const shutterFirst = (type) => !!type && type.preset !== 'book';

/** Whether the barcode detector runs for this type (it has an ISBN or EAN field). */
export const readsBarcodes = isScannable;
